module.exports = __webpack_public_path__ + "img/IMG_0688.01a3634a.jpg";